import React, { useEffect, useState } from "react";
import "./styles.scss";
import Birthday from "../../components/birthday";
import Gender from "../../components/gender";
import SubmitInfomation from "../../components/submitInfo";
import CancelInfomation from "../../components/cancelInfo";
import stringJp from '../../constants/stringJP';
import useWindowDimensions from "../../components/useWindowDemision";
import moment from 'moment';

function InformationMember() {

    const dateFroms = moment().subtract(30, 'year');
    const dataF = dateFroms.toISOString().split('T')[0];
    const dateDf= `${dataF.slice(0, 4)}/${dataF.slice(5, 7)}/${dataF.slice(8, 10)}`;

    const key = new URL(window.location.href);
    const paramsUrl = key.searchParams;
    const index_card = paramsUrl.get("index_card");
    const [name, setName] = useState("");
    const [gender, setGender] = useState(null);
    const [birthday, setBirthday] = useState(dateDf);
    const [dataMember, setDataMember] = useState([]);
    const [isTypingName, setIsTypingName] = useState(false);
    const [isCheck, setIsCheck] = useState(false);
    const account_id = localStorage.getItem('account_id');
    const dataUserAdmin = JSON.parse(localStorage.getItem("DATA_MEMBER_ADMIN"));
    const dataMemberRd = JSON.parse(localStorage.getItem("DATA_MEMBER_FM"));
    const { height } = useWindowDimensions();

    useEffect(() => {

        if (index_card) {
            const dataDetail = dataMemberRd[index_card];
            setName(dataDetail?.name);
            setGender(dataDetail?.gender);
            setBirthday(dataDetail?.birthday.length === 0 ? dateDf : dataDetail?.birthday);
            if (dataDetail === undefined) {
                setName(dataUserAdmin.account_name);
                setGender(dataUserAdmin.gender);
                setBirthday(dataUserAdmin.birthday);
                if (dataUserAdmin.birthday === "") {
                    setBirthday(dateDf);
                }
            }
        }
        setDataMember([...dataMemberRd]);
        setIsCheck(true);

        return () => { // This code runs when component is unmounted
            setName("");
            setGender(null);
            setBirthday(dateDf);
            setDataMember([]);
            setIsCheck(false);
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleChangeName = (e) => {
        setIsTypingName(true);
        setName(e.target.value);
    };

    const handleCheckDisableName = () => {
        if (index_card === "0") {
            return true
        } else {
            return false
        }
    };

    const rememberMe = localStorage.getItem('isCheckBirth');
    const dateIsEdit = new Date(new Date(rememberMe).setDate(new Date(rememberMe).getDate() + 30));

    return (
        <div className="information" style={{ minHeight: height }}>
            <div>
                <p className="info-name">{stringJp.label_name_info}</p>
                <div className="name">
                    <input
                        type="text"
                        onChange={(e) => handleChangeName(e)}
                        value={name}
                        disabled={handleCheckDisableName()}
                        className="input-name"
                    // onkeypress="return isNumberKey(event)"
                    />
                </div>
                {name?.length > 20 ? <p className="input-length">{stringJp.label_validate_name_max}</p> : ""}
                {isTypingName && name?.length === 0 && <p className="input-length">{stringJp.label_validate_name_min}</p>}
            </div>
            <div>
                <p className="info-birth">{stringJp.label_birthday_info}</p>
                <div className="birth">
                    <Birthday
                        setBirthday={setBirthday}
                        birthday={birthday}
                        isCheck={isCheck}
                        index_card={index_card}
                        dateIsEdit={dateIsEdit}
                    />
                </div>
            </div>
            {/* birthday */}
            <div>
                <p className="info-gender">{stringJp.label_gender_info}</p>
                <div className="gender">
                    <Gender setGender={setGender} gender={gender} />
                </div>
            </div>
            {/* gender */}
            <SubmitInfomation
                gender={gender}
                name={name}
                dataMember={dataMember}
                dataDate={birthday}
                index_card={index_card}
                account_id={account_id}
                setIsTypingName={setIsTypingName}
            />
            <CancelInfomation
                account_id={account_id}
            />
        </div>
    );
}

export default InformationMember;
